import actionTypes from '../constants/action-types';

const setSelectedElement = (elementId, options = {}) => ({
  type: actionTypes.SET_SELECTED_ELEMENT,
  payload: {
    elementId,
    options,
  },
});

export default setSelectedElement;
